<!--坏件库修改页面-->
<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="max-dialog"
             center
             :close-on-click-modal="false"
             :modal="true">
    <div>
      <div class="search-content">
        <el-col :span="24" class="toobar">
          <el-col :span="24">
          <el-col :span="5">
            <span class="demonstration">请选择处理方式:</span>
            <el-select v-model="value" placeholder="请选择" style="width: 140px;">
              <el-option
                v-for="item in brokenpartsType"
                :key="item.value"initData
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
            <el-col :span="4" v-if="value==30">
              <el-select v-model="movecangkucode" placeholder="请选择" style="width: 180px;" @change="changenamemove" :required="true"
                         size="max">
                <el-option
                  v-for="item in jxcstoreDataAll"
                  :key="item.cangkucode" v-if="cangkucode!=item.cangkucode"
                  :label="item.cangkuname"
                  :value="item.cangkucode">
                </el-option>
              </el-select>
            </el-col>
          <el-col :span="4" v-if="value==20">
            <el-input v-model="pcustomer" auto-complete="off" :required="true"
                      @click.native="changepcustomer" placeholder="请选择供应商"></el-input>
          </el-col>
          <el-col :span="6" v-show="value==5 || value==10 || value==11 || value==20|| value==30">
            <el-input type="textarea" v-model="remark"/>
          </el-col>
          <el-col :span="6">总数：{{totalnumber}}    &nbsp;&nbsp;本次处理：{{subnumber}}</el-col>
          </el-col>
          <el-col :span="5">
            <AutoCustomer @clear="clearCustomerName" :size="'small'"
                          @handleSelect="afterSelExternalDept"></AutoCustomer>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="输入商品名称或编码" size="small" v-model="seedsearch" clearable style="width: 180px" @change="searchData()"></el-input>
            &nbsp;
           <el-checkbox v-model="showCat" @change="bindGrid()" v-if="false">按系列显示</el-checkbox>
            <el-checkbox v-model="selectallnum" @change="selectAll($event,'all')">全选</el-checkbox>
            <el-checkbox @change="selectAll($event,'has')" v-if="false">含订单</el-checkbox>
            <el-checkbox @change="selectAll($event,'no')" v-if="false">无订单</el-checkbox>
            <el-input style="width: 120px" size="small" v-model="onlycode"
                      onfocus="this.select()" placeholder="扫唯一码" v-if="false" @change="toponlyonecode()"></el-input>
          </el-col>
        </el-col>
      </div>
      <!--:default-sort = "{prop: 'needhandlenumber', order: 'descending'}"-->
      <el-table
        :data="tableData.filter(data => data.show!=-1)"
        :height="tableHeight(200)"
        size="mini"
        stripe
        border v-if="showtable"
        style="width: 100%;">
        <el-table-column
          prop="erpserial" width="120"
          label="坏件入库单号"
          header-align="center"
          align="center" >
          <template slot-scope="scope">
                  <span @click="lookbaosundan(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.erpserial}}
                  </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ordernum"
          label="销售单号"
          header-align="center"
          align="center"
          width="140" >
          <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum}}
                  </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="buyordernum"
          label="采购单号"
          header-align="center"
          align="center"
          width="120" >
        </el-table-column>
        <el-table-column
          prop="seedname"
          label="名称" width="180"
          :show-overflow-tooltip="true"
          header-align="center"
          align="left">
        </el-table-column>
        <el-table-column
          prop="seedcode"
          label="编码"
          header-align="center"
          width="120" :show-overflow-tooltip="true"
          align="left">
        </el-table-column>
        <el-table-column
          prop="packagesize"
          label="规格"
          align="left" :show-overflow-tooltip="true"
          header-align="center" width="150">
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="customername"
          label="责任人" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="80">
        </el-table-column>
        <el-table-column
          prop="ordername"
          label="类别"
          align="left"
          header-align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="remarkdetail"
          label="备注" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="200">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="原因" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="200">
        </el-table-column>
        <el-table-column
          prop="accdate"
          label="入库日期"
          header-align="center"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="cangkuname"
          label="仓库" :show-overflow-tooltip="true"
          header-align="center"
          align="left"
          width="100">
        </el-table-column>
        <el-table-column
          prop="uname"
          label="录入人"
          header-align="center"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="totalnumber" fixed="right"
          label="数量"
          header-align="center"
          align="right"
          width="70">
          <template slot-scope="scope">
            {{(scope.row.totalnumber-scope.row.handlenumber)}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
          label="备注"
          header-align="center"
          align="right"
          width="80">
          <template slot-scope="scope">
            <el-button size="mini" style="float: left" @click="setBeiZhu(scope.row)">备注</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="镜片状态"
                         header-align="center"
                         align="right"
                         width="110">
          <template slot-scope="scope">
            <el-select v-model="scope.row.mosunstatus" placeholder="请选择" size="mini">
              <el-option  label="" value=""></el-option>
              <el-option  label="已磨" value="已磨"></el-option>
              <el-option  label="未磨" value="未磨"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="needhandlenumber" fixed="right"
          label="处理数量" width="120"
          header-align="center"
          align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.status==1" style="color: red"><b>待审核</b></div>
            <div v-else>
            {{scope.row.bom}}
            <div v-if="scope.row.barcodes&&scope.row.barcodes.length>0">
              <el-checkbox v-for="item in scope.row.barcodes" :checked="ischeck(scope.row,item)" :label="item.storegoodsbarcode" :ref="item.unitguid" :key="item.unitguid" @change="changeBar(scope.row,item,$event)">{{item.storegoodsbarcode}}（{{item.saleordernum?item.saleordernum:'无'}}）</el-checkbox><br/>
            </div>
            <el-input placeholder="请输入数量" width="100px" size="mini" v-else v-model="scope.row.needhandlenumber" @blur="changnum(scope.row)">
            </el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--<BrokenPartsEdit ref="DataContactEdit"></BrokenPartsEdit>-->
      <ExternaldeptChaiDanSel ref="zhuandan" :unitgroup="3"
                              @select="selectpcustomer" :title="'选择供应商'"></ExternaldeptChaiDanSel>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid"></CstagreementEdit>
      <StorageBadOut ref="StorageBadOut"></StorageBadOut>
      <CstagreementEdit ref="DataContactEditCopy" @bindGrid="bindGrid"></CstagreementEdit>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" class="qrbtn" @click="update" :loading="loading" v-if="!bimanage">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {getBadStoreListData,badpartslist} from '@/api/set/warehouse'
  import {updateBrokenparks} from '@/api/set/csagreement';
  import StorageBadOut from './StorageBadOut';
  import {getListDatabyinpd, getListDataall, cusandptbyind} from '@/api/set/jxcstore';
  import {updatestoredetail} from '@/api/set/jxcstoreformdetail';
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel'
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import AutoComplete from "@/components/common/AutoCustomer";
  import {isUGO} from '@/api/login';

  export default {
    name: 'StorageBadEdit',
    data() {
      return {
        msg: '坏件出库操作',
        userInfoModel: {},
        selectallnum:false,
        loading:false,
        customername:'',
        customerserial:'',
        subnumber:0,
        totalnumber:0,
        dialogFormVisible: false,
        searchdata: "",
        seedcode: '',
        onlycode:'',
        showCat:true,
        categorycode:'',
        seedsearch:'',
        seedcodes: '',
        remark: '',
        bimanage:false,
        cangkucode: '',
        cangkuname: '',
        jxcstoreDataAll:[],
        movecangkucode: '',
        movecangkuname: '',
        title: '',
        showtable:true,
        loading: true,
        independentserial: "",
        value: '',
        brokenpartsType: [
          {value: 5, name: "损耗"},
          {value: 10, name: "入正式库"},
          {value: 11, name: "原片使用"},
          {value: 20, name: "退回供应商"},
          {value: 30, name: "转其他仓库"},
        ],
        pcustomer: '',
        pcustomerserial: '',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],


      }
    },
    methods: {
      clearCustomerName() {
        this.customername = ""
        this.customerserial = ""
        this.bindGrid()
      },
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.bindGrid()
      },
      selectAll(event, type) {
        // this.showtable = false
        this.subnumber = 0
        for (let i in this.tableData) {
          if(this.tableData[i].status==1||this.tableData[i].status==-1) continue;

          this.tableData[i].needhandlenumber= this.tableData[i].totalnumber- this.tableData[i].handlenumber;
          this.subnumber+= this.tableData[i].needhandlenumber;
          // for (let j in this.tableData[i].barcodes) {
          //   if (type == 'all') {
          //     this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], event);
          //   } else {
          //     if (type == 'has') {
          //       if (event)
          //         this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], this.tableData[i].barcodes[j].saleordernum);
          //     } else {
          //       if (event)
          //         this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], !this.tableData[i].barcodes[j].saleordernum);
          //     }
          //   }
          // }
        }
        // this.$nextTick(() => {
        //   this.showtable = true
        // });
      },
      setBeiZhu(row) {
        var showMessage = row.remarkdetail;
        this.$prompt('', '请输入备注', {
          inputValue: showMessage,
          confirmButtonText: '保存',
          cancelButtonText: '取消',
        }).then(({value}) => {
          showMessage = value;
          updatestoredetail({unitguid:row.unitguid,remark:showMessage}).then(respMSG=>{
            row.remarkdetail=value;
            this.$message({type: 'success',message: '保存成功！' });
          })
        }).catch(() => {
        });
      },
      toponlyonecode() {
        if (!this.onlycode)
          return;

        for (let i in this.tableData) {
          for (let j in this.tableData[i].barcodes) {
            if (this.tableData[i].barcodes[j].storegoodsbarcode == this.onlycode) {
              this.showtable = false
              this.onlycode = ''
              this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], true);
              break;
            }
          }
        }
        if (!this.showtable) {
          this.$nextTick(() => {
            this.showtable = true
          });
        }
      },
      ischeck(item, checks) {
        return (item.selectBars.indexOf(';' + checks.unitguid + ';') > -1);
      },
      changeBar(item, checks, event) {
        if (item.selectBars.indexOf(';' + checks.unitguid + ';') > -1) {
          if (!event) {
            item.selectBars = item.selectBars.replace(';' + checks.unitguid + ';', ';');
            item.needhandlenumber -= 1;
            this.subnumber -= 1;
          }
        } else {
          if (event) {
            item.selectBars += checks.unitguid + ';';
            if (item.needhandlenumber)
              item.needhandlenumber += 1;
            else
              item.needhandlenumber = 1;
            this.subnumber += 1;
          }
        }
        console.log(item.selectBars)
      },
      isEqualIndependentSerial(item) {//总部人员只能操作总部的数据，加工中心只能操作加工中心的数据
        return this.userInfoModel.independentserial == (item.independentserial || "")
      },

      selectpcustomer(pcustomerserial, pcustomer) {
        this.pcustomerserial = pcustomerserial
        this.pcustomer = pcustomer
      },
      changepcustomer() {
        this.seedcodes = []

        for (let i in this.tableData) {
          if (this.tableData[i]["needhandlenumber"] && this.tableData[i]["needhandlenumber"] > 0) {
            if (this.seedcodes.indexOf(this.tableData[i].seedcode) == -1)
              this.seedcodes.push(this.tableData[i].seedcode)
          }
        }
        if(this.seedcodes.length==0){
          if (this.seedcode) {
            this.seedcodes.push(this.seedcode)
          }
        }
        this.$refs.zhuandan.initData(this.seedcodes)
        this.$refs.zhuandan.show()
      },
      changnum(item) {
        let res = /^[+]{0,1}(\d+)$/
        let num = item.needhandlenumber;
        if (num) {
          if (num != undefined && !res.test(num)) {
            this.$message({
              message: "请输入正确的数字",
              type: 'error'
            })
            item.needhandlenumber = ''
          } else if (item.totalnumber - item.handlenumber - num < 0) {
            this.$message({
              message: "处理数量需要小于总数",
              type: 'error'
            })
            item.needhandlenumber = ''
          }

          this.subnumber = 0
          for (let i in this.tableData) {
            this.subnumber += this.tableData[i].needhandlenumber ? parseInt(this.tableData[i].needhandlenumber) : 0;
          }
        }
      },
      changenamemove(val){
        for (let i in this.jxcstoreDataAll) {
          if (this.jxcstoreDataAll[i].cangkucode == val) {
            this.movecangkuname = this.jxcstoreDataAll[i].cangkuname;
          }
        }
      },
      //查看订单
      lookdingdan(item) {
        if (item["ordernum"]) {
          var s = {
            erpserial: item["ordernum"]
          }
          this.$refs.DataContactEdit.initData(s)
          this.$refs.DataContactEdit.show()
          this.$refs.DataContactEdit.yincangdayin('order')
        }
      },
      lookbaosundan(item) {
        this.$refs.BaoSunDetail.show(item.erpserial, false)
      },
      lookDetailsCopy(row) {
        this.$refs.DataContactEditCopy.initData(row)
        this.$refs.DataContactEditCopy.show()
      },
      errorMsg(msg){
        this.$message({
          message: msg,
          type: 'error'
        })
        this.loading=false;
      },
      update() {
        this.loading = true;
        if (!this.value) {
          this.errorMsg('请选择处理方式');
          return
        }
        if (this.value == 5 && !this.remark) {
          this.errorMsg('请输入损坏原因');
          return
        }
        if ((this.value == 10||this.value == 11) && !this.cangkucode) {
          this.errorMsg('请选择仓库');
          return
        }
        if (this.value == 30 && !this.movecangkucode) {
          this.errorMsg('请选择仓库');
          return
        }
        if (this.value == 20 && !this.pcustomerserial) {
          this.errorMsg('请选择供应商');
          return;
        }
        var needMosunSel=isUGO();

        let brokenlist = [];
        var barUnitguid = '';
        if (this.tableData) {
          for (let i in this.tableData) {
            let obj = {
              unitguid: '',
              needhandlenumber: '',
            }
            if (this.tableData[i].barcodes && this.tableData[i].barcodes.length > 0) {
              var num = 0;
              var bars = this.tableData[i].selectBars.split(';')
              for (var m = 0; m < bars.length; m++) {
                if (bars[m]) {
                  barUnitguid += bars[m] + ';';//选择的条码
                  num++;
                }
              }
              this.tableData[i]["needhandlenumber"] = num;
            }
            if (this.tableData[i]["needhandlenumber"] && this.tableData[i]["needhandlenumber"] > 0) {
              if(needMosunSel){
                if(this.tableData[i].packagesize&&this.tableData[i].packagesize.indexOf('"X"')>-1&&!this.tableData[i].mosunstatus){
                  this.errorMsg('镜片状态必须选择！');
                  return;
                }
              }
              obj["mosunstatus"] = this.tableData[i]["mosunstatus"]
              obj["unitguid"] = this.tableData[i]["unitguid"]
              obj["needhandlenumber"] = this.tableData[i]["needhandlenumber"]
              brokenlist.push(obj)
            }
          }
        }
        if (brokenlist && brokenlist.length > 0) {
          if (this.value == 30) {
            if (this.remark) {
              this.remark += "（从" + this.cangkuname + " 转入" + this.movecangkuname + "）";
            } else
              this.remark = "从" + this.cangkuname + " 转入" + this.movecangkuname;
          }
          var handlemode = ''
          for (let i = 0; i < this.brokenpartsType.length; i++) {
            if (this.value) {
              if (this.brokenpartsType[i].value == this.value) {
                handlemode = this.brokenpartsType[i].name
              }
            }
          }

          updateBrokenparks(
            {
              brokenlist: JSON.stringify(brokenlist),
              remark: this.remark,
              cangkucode: this.cangkucode,
              cangkuname: this.cangkuname,
              movecangkucode:this.movecangkucode,
              movecangkuname:this.movecangkuname,
              pcustomerserial: this.pcustomerserial,
              pcustomer: this.pcustomer,
              value: this.value,
              barunitguid: barUnitguid,
              handlemode: handlemode
            }
          ).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$refs.StorageBadOut.show(response.data.erpserial);
              this.$emit('bindGrid');
              this.dialogFormVisible = false;
            } else {
              this.errorMsg(response.data.msg);
            }
          })
        } else {
          this.errorMsg("请选择退货产品")
        }
      },
      initData(item) {
        this.loading=false;
        this.selectallnum=false;
        this.categorycode = item.categorycode
        this.seedcode = item.seedcode
        this.cangkucode = item.cangkucode
        this.cangkuname = item.cangkuname
        if(item.cangkucode==this.jxcstoreDataAll[0].cangkucode){
          this.movecangkucode=''
          this.movecangkuname=''
        }else {
          this.movecangkucode = this.jxcstoreDataAll[0].cangkucode
          this.movecangkuname = this.jxcstoreDataAll[0].cangkuname
        }
        this.pcustomerserial = ''
        this.pcustomer = ''
        this.remark = ''
        this.title = item.categoryname + "坏件处理"
        this.value = ''
        this.subnumber = 0;
        this.customerserial = ''
        this.customername = ''
        this.seedsearch = ''
        this.bindGrid();
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if (temp.M) {
            s=temp.M+'/'+temp.C
          } else {
            s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          }
          if (temp.type) {
            s = temp.type + " " + s
          }
        }
        return s
      },
      searchData() {
        this.showtable = false;
        for (var i = 0; i < this.tableData.length; i++) {
          this.tableData[i].show = 1;
          if (this.seedsearch) {
            if (!(this.tableData[i].seedcode.indexOf(this.seedsearch) > -1 ||
              this.tableData[i].seedname.indexOf(this.seedsearch) > -1)) {
              this.tableData[i].show = -1;
            }
          }
        }
        this.$nextTick(() => {
          this.showtable = true
        });
      },
      bindGrid() {
        this.tableData = []
        this.dialogFormVisible = true;
        badpartslist({
          formtype: 78,
          seedcode: (this.showCat ? '' : this.seedcode),
          categorycode: (this.showCat ? this.categorycode : ''),
          cangkucode: this.cangkucode,
          status: 20,
          customerserial: this.customerserial
        }).then(response => {
          var returnD = response.data.obj
          this.totalnumber=0;
          for (var i = 0; i < returnD.length; i++) {
            returnD[i].selectBars = ';';
            returnD[i].mosunstatus='';
            returnD[i].needhandlenumber = '';// this.tableData[i].totalnumber - this.tableData[i].handlenumber
            this.totalnumber+=returnD[i].totalnumber - returnD[i].handlenumber;
          }
          this.tableData=returnD;
          this.searchData();
        })
      },
    },
    components: {
      ExternaldeptChaiDanSel,
      CstagreementEdit,
      BaoSunDetail,
      AutoComplete,
      StorageBadOut
    },

    mounted() {
      this.bimanage=this.$route.query.bimanage?true:false;
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;

      //全部仓库
      getListDataall().then(response => {
        this.jxcstoreDataAll =response.data.obj
      });
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadEdit.vue